import { parseDocument as k, isSeq as C, isMap as U, isScalar as R } from "yaml";
import { d as V, n as H } from "./defaultFormRuntime-BUO8dKCN.js";
import { z as p } from "zod";
const Q = p.object({
  id: p.string().optional(),
  type: p.string().optional(),
  questionType: p.string().optional(),
  title: p.string().optional(),
  description: p.string().optional(),
  required: p.boolean().optional(),
  options: p.array(
    p.union([
      p.string(),
      p.object({
        value: p.string().optional(),
        label: p.string().optional()
      }).passthrough()
    ])
  ).optional(),
  config: p.record(p.unknown()).optional(),
  validation: p.record(p.unknown()).optional()
}).passthrough(), G = p.object({
  id: p.string().optional(),
  title: p.string().optional(),
  description: p.string().optional(),
  elements: p.array(Q).optional()
}).passthrough(), Y = p.object({
  id: p.string().optional()
}).passthrough(), W = p.object({
  version: p.number().optional(),
  kind: p.string().optional(),
  id: p.string().optional(),
  metadata: p.object({
    title: p.string().optional(),
    description: p.string().optional(),
    locale: p.string().optional()
  }).passthrough().optional(),
  theme: Y.optional(),
  navigation: p.object({
    mode: p.enum(["single-page", "paged"]).optional()
  }).passthrough().optional(),
  pages: p.array(G).optional()
}).passthrough();
function K(t) {
  let e = 2166136261;
  for (let i = 0; i < t.length; i += 1)
    e ^= t.charCodeAt(i), e = Math.imul(e, 16777619);
  return `fnv1a:${(e >>> 0).toString(16).padStart(8, "0")}`;
}
function c(t, e, i = {}) {
  return {
    code: t,
    severity: i.severity ?? "error",
    message: e,
    path: i.path,
    range: i.range,
    pageId: i.pageId,
    elementId: i.elementId,
    hint: i.hint,
    related: i.related
  };
}
function M(t, e, i) {
  return {
    start: I(t, e),
    end: I(t, i)
  };
}
function I(t, e) {
  const i = Math.max(0, Math.min(e, t.length));
  let n = 1, o = 1;
  for (let r = 0; r < i; r += 1)
    t[r] === `
` ? (n += 1, o = 1) : o += 1;
  return {
    offset: i,
    line: n,
    column: o
  };
}
function l(t, e) {
  if (e.length === 0)
    return M(t, 0, Math.min(t.length, nt(t)));
  const i = B(t, e);
  if (i)
    return i;
  const n = t.split(/\n/).map((r, s, u) => ({
    index: s,
    startOffset: rt(u, s),
    text: r,
    indent: ot(r),
    trimmed: r.trim()
  })).filter((r) => r.trimmed.length > 0 && !r.trimmed.startsWith("#")), o = F(n, 0, n.length, 0, e);
  if (o)
    return it(t, o.line, o.token);
}
function B(t, e) {
  try {
    const i = k(t, { keepSourceTokens: !0, prettyErrors: !1 });
    if (i.errors.length > 0 || !i.contents)
      return;
    const n = $(i.contents, e);
    return n ? J(t, n) : void 0;
  } catch {
    return;
  }
}
function $(t, e) {
  const [i, ...n] = e;
  if (i === void 0)
    return t.range ?? void 0;
  if (C(t) && D(i)) {
    const r = t.items[Number(i)];
    return !r || !j(r) ? void 0 : n.length === 0 ? r.range ?? void 0 : $(r, n);
  }
  if (!U(t))
    return;
  const o = t.items.find((r) => R(r.key) && String(r.key.value) === i);
  if (!(!o || !j(o.key)))
    return n.length === 0 ? o.key.range ?? void 0 : o.value && j(o.value) ? $(o.value, n) : void 0;
}
function J(t, e) {
  const [i, n] = e;
  if (!(typeof i != "number" || typeof n != "number"))
    return M(t, i, Math.max(i, n));
}
function j(t) {
  return !!(t && typeof t == "object" && "range" in t);
}
function F(t, e, i, n, o) {
  const [r, ...s] = o;
  if (r !== void 0) {
    if (D(r)) {
      const u = X(t, e, i, n, Number(r));
      if (!u)
        return;
      if (s.length === 0)
        return { line: u.line, token: "-" };
      const a = et(u.line, s[0]);
      return a && s.length === 1 ? { line: u.line, token: a } : F(t, u.childStart, u.childEnd, u.line.indent + 2, s);
    }
    for (let u = e; u < i; u += 1) {
      const a = t[u];
      if (!a || a.indent < n)
        break;
      if (a.indent === n && tt(a, r))
        return s.length === 0 ? { line: a, token: r } : F(t, u + 1, x(t, u + 1, i, n), n + 2, s);
    }
  }
}
function X(t, e, i, n, o) {
  let r = -1;
  for (let s = e; s < i; s += 1) {
    const u = t[s];
    if (!u || u.indent < n)
      break;
    if (!(u.indent !== n || !u.trimmed.startsWith("-")) && (r += 1, r === o))
      return {
        line: u,
        childStart: s + 1,
        childEnd: Z(t, s + 1, i, n)
      };
  }
}
function Z(t, e, i, n) {
  for (let o = e; o < i; o += 1) {
    const r = t[o];
    if (!r || r.indent < n || r.indent === n && r.trimmed.startsWith("-"))
      return o;
  }
  return i;
}
function x(t, e, i, n) {
  for (let o = e; o < i; o += 1) {
    const r = t[o];
    if (r && r.indent <= n)
      return o;
  }
  return i;
}
function tt(t, e) {
  return new RegExp(`^${w(e)}\\s*:`).test(t.trimmed);
}
function et(t, e) {
  if (e)
    return new RegExp(`^-\\s+${w(e)}\\s*:`).test(t.trimmed) ? e : void 0;
}
function it(t, e, i) {
  const n = Math.max(0, e.text.indexOf(i)), o = e.startOffset + n;
  return M(t, o, o + i.length);
}
function nt(t) {
  const e = t.indexOf(`
`);
  return e >= 0 ? e : t.length;
}
function rt(t, e) {
  var n;
  let i = 0;
  for (let o = 0; o < e; o += 1)
    i += ((n = t[o]) == null ? void 0 : n.length) ?? 0, i += 1;
  return i;
}
function ot(t) {
  const e = /^ */.exec(t);
  return (e == null ? void 0 : e[0].length) ?? 0;
}
function D(t) {
  return /^\d+$/.test(t);
}
function w(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const z = "qualiopi.subject-progress.v1", st = /* @__PURE__ */ new Set(["version", "kind", "preset", "id", "metadata", "theme", "navigation", "qualiopi", "outputs"]), at = /* @__PURE__ */ new Set(["title", "description", "locale"]), ut = /* @__PURE__ */ new Set(["audience", "training", "subjects"]), lt = /* @__PURE__ */ new Set(["title"]), pt = /* @__PURE__ */ new Set(["id", "label"]), O = /* @__PURE__ */ new Set(["hot", "cold"]);
function ct(t, e, i, n) {
  if (t.kind !== "form-preset")
    return { expanded: t, blocking: !1 };
  i.push(...L(t, st, [], e, n)), t.version !== 1 && i.push(
    c("FORM_UNSUPPORTED_VERSION", "Seule la version 1 est supportee pour les presets.", {
      path: ["version"],
      range: l(e, ["version"]),
      severity: "error",
      hint: "Mettez version: 1."
    })
  ), t.preset !== z && i.push(
    c("FORM_INVALID_KIND", `Le preset "${typeof t.preset == "string" ? t.preset : "(vide)"}" est inconnu.`, {
      path: ["preset"],
      range: l(e, ["preset"]),
      severity: "error",
      hint: `Utilisez preset: ${z}.`
    })
  );
  const o = T(t.metadata);
  i.push(...L(o, at, ["metadata"], e, n));
  const r = T(t.qualiopi);
  N(t.qualiopi) || i.push(
    c("SCHEMA_MISSING_FIELD", "Le preset Qualiopi doit definir qualiopi.subjects.", {
      path: ["qualiopi"],
      range: l(e, ["qualiopi"]),
      severity: n === "strict" ? "error" : "warning",
      hint: "Ajoutez qualiopi.subjects avec au moins un sujet."
    })
  ), i.push(...L(r, ut, ["qualiopi"], e, n));
  const s = T(r.training);
  i.push(...L(s, lt, ["qualiopi", "training"], e, n));
  const u = ft(t.outputs, e, i, n), a = mt(r.subjects, e, i, n), d = i.some((g) => g.severity === "error");
  return n === "strict" && d ? { expanded: null, blocking: !0 } : {
    expanded: dt(t, o, s, a, u),
    blocking: !1
  };
}
function dt(t, e, i, n, o) {
  const r = _(i.title, _(e.title, "Formation"));
  return {
    version: 1,
    kind: "form",
    id: _(t.id, "qualiopi-subject-progress"),
    metadata: {
      title: _(e.title, `Questionnaire Qualiopi - ${r}`),
      description: _(
        e.description,
        "Questionnaire genere a partir des sujets de formation pour le suivi Qualiopi."
      ),
      locale: _(e.locale, "fr-FR")
    },
    theme: t.theme,
    navigation: N(t.navigation) ? t.navigation : { mode: "paged" },
    pages: [
      ...o.includes("hot") ? [gt(n)] : [],
      ...o.includes("cold") ? [ht(n)] : []
    ]
  };
}
function gt(t) {
  return {
    id: "qualiopi_hot",
    title: "Evaluation a chaud",
    description: "Progression ressentie et satisfaction immediate.",
    elements: [
      {
        id: "hot_intro",
        type: "statement",
        title: "Votre retour a chaud",
        description: "Indiquez les sujets sur lesquels vous avez progresse pendant la formation."
      },
      ...t.map((e) => ({
        id: `hot_progress_${e.id}`,
        type: "question",
        questionType: "linear-scale",
        title: `J'ai progresse sur : ${e.label}`,
        required: !0,
        config: {
          min: 1,
          max: 5,
          minLabel: "Pas du tout",
          maxLabel: "Tout a fait"
        }
      })),
      {
        id: "hot_useful_subjects",
        type: "question",
        questionType: "multiple-choice",
        title: "Quels sujets vous semblent les plus utiles pour votre activite ?",
        options: t.map((e) => e.label)
      },
      {
        id: "hot_global_satisfaction",
        type: "question",
        questionType: "rating",
        title: "Votre satisfaction globale",
        required: !0,
        config: { max: 5 }
      },
      {
        id: "hot_difficulty_or_claim",
        type: "question",
        questionType: "long-text",
        title: "Souhaitez-vous signaler une difficulte, une reclamation ou un point bloquant ?",
        validation: { maxLength: 2e3 }
      },
      {
        id: "hot_comment",
        type: "question",
        questionType: "long-text",
        title: "Autre commentaire",
        validation: { maxLength: 2e3 }
      }
    ]
  };
}
function ht(t) {
  return {
    id: "qualiopi_cold",
    title: "Evaluation a froid",
    description: "Utilisation effective des sujets apres la formation.",
    elements: [
      {
        id: "cold_intro",
        type: "statement",
        title: "Votre retour a froid",
        description: "Indiquez les sujets que vous avez pu utiliser en situation reelle."
      },
      ...t.flatMap((e) => [
        {
          id: `cold_used_${e.id}`,
          type: "question",
          questionType: "yes-no",
          title: `Avez-vous utilise ce sujet : ${e.label} ?`,
          required: !0
        },
        {
          id: `cold_usefulness_${e.id}`,
          type: "question",
          questionType: "linear-scale",
          title: `Si oui, ce sujet vous a-t-il ete utile : ${e.label} ?`,
          config: {
            min: 1,
            max: 5,
            minLabel: "Peu utile",
            maxLabel: "Tres utile"
          }
        }
      ]),
      {
        id: "cold_usage_context",
        type: "question",
        questionType: "long-text",
        title: "Dans quelles situations avez-vous utilise les acquis ?",
        validation: { maxLength: 2e3 }
      },
      {
        id: "cold_blockers",
        type: "question",
        questionType: "multiple-choice",
        title: "Qu'est-ce qui a limite l'utilisation des acquis ?",
        options: ["Pas eu l'occasion", "Manque de temps", "Contexte non adapte", "Besoin d'accompagnement", "Autre"]
      },
      {
        id: "cold_additional_need",
        type: "question",
        questionType: "yes-no",
        title: "Un complement ou un accompagnement serait-il utile ?"
      },
      {
        id: "cold_comment",
        type: "question",
        questionType: "long-text",
        title: "Autre commentaire",
        validation: { maxLength: 2e3 }
      }
    ]
  };
}
function ft(t, e, i, n) {
  if (t === void 0)
    return ["hot", "cold"];
  if (!Array.isArray(t))
    return i.push(
      c("SCHEMA_INVALID_VALUE", "outputs doit etre une liste contenant hot et/ou cold.", {
        path: ["outputs"],
        range: l(e, ["outputs"]),
        severity: n === "strict" ? "error" : "warning"
      })
    ), ["hot", "cold"];
  const o = t.filter((r) => typeof r == "string" && O.has(r));
  return t.forEach((r, s) => {
    (typeof r != "string" || !O.has(r)) && i.push(
      c("SCHEMA_INVALID_VALUE", 'outputs accepte uniquement "hot" et "cold".', {
        path: ["outputs", String(s)],
        range: l(e, ["outputs", String(s)]),
        severity: n === "strict" ? "error" : "warning"
      })
    );
  }), o.length === 0 ? (i.push(
    c("SCHEMA_INVALID_VALUE", "Le preset doit generer au moins un questionnaire.", {
      path: ["outputs"],
      range: l(e, ["outputs"]),
      severity: n === "strict" ? "error" : "warning",
      hint: 'Utilisez outputs: ["hot", "cold"], ["hot"] ou ["cold"].'
    })
  ), ["hot", "cold"]) : Array.from(new Set(o));
}
function mt(t, e, i, n) {
  if (!Array.isArray(t))
    return i.push(
      c("SCHEMA_MISSING_FIELD", "Le preset Qualiopi doit definir une liste de sujets.", {
        path: ["qualiopi", "subjects"],
        range: l(e, ["qualiopi", "subjects"]),
        severity: n === "strict" ? "error" : "warning",
        hint: "Ajoutez au moins un sujet avec id et label."
      })
    ), [];
  const o = [], r = /* @__PURE__ */ new Set();
  return t.forEach((s, u) => {
    const a = ["qualiopi", "subjects", String(u)];
    if (!N(s)) {
      i.push(
        c("SCHEMA_INVALID_VALUE", "Chaque sujet doit etre un objet.", {
          path: a,
          range: l(e, a),
          severity: n === "strict" ? "error" : "warning"
        })
      );
      return;
    }
    i.push(...L(s, pt, a, e, n));
    const d = typeof s.label == "string" ? s.label.trim() : "", g = typeof s.id == "string" && s.id.trim().length > 0 ? s.id.trim() : St(d);
    if (d.length === 0) {
      i.push(
        c("SCHEMA_MISSING_FIELD", "Chaque sujet doit definir un label.", {
          path: [...a, "label"],
          range: l(e, [...a, "label"]) ?? l(e, a),
          severity: n === "strict" ? "error" : "warning"
        })
      );
      return;
    }
    if (!/^[a-z][a-z0-9_]*$/.test(g)) {
      i.push(
        c("SCHEMA_INVALID_VALUE", `L'id de sujet "${g}" est invalide.`, {
          path: [...a, "id"],
          range: l(e, [...a, "id"]) ?? l(e, a),
          severity: n === "strict" ? "error" : "warning",
          hint: "Utilisez un id stable en minuscules avec lettres, chiffres et underscores."
        })
      );
      return;
    }
    if (r.has(g)) {
      i.push(
        c("ELEMENT_DUPLICATE_ID", `L'id de sujet "${g}" est duplique.`, {
          path: [...a, "id"],
          range: l(e, [...a, "id"]) ?? l(e, a),
          severity: n === "strict" ? "error" : "warning"
        })
      );
      return;
    }
    r.add(g), o.push({ id: g, label: d });
  }), o.length === 0 && i.push(
    c("SCHEMA_MISSING_FIELD", "Le preset Qualiopi doit contenir au moins un sujet valide.", {
      path: ["qualiopi", "subjects"],
      range: l(e, ["qualiopi", "subjects"]),
      severity: n === "strict" ? "error" : "warning"
    })
  ), o;
}
function L(t, e, i, n, o) {
  return Object.keys(t).filter((r) => !e.has(r)).map(
    (r) => c("SCHEMA_UNKNOWN_FIELD", `Champ inconnu "${r}".`, {
      severity: o === "strict" ? "error" : "warning",
      path: [...i, r],
      range: l(n, [...i, r]),
      hint: "Supprimez ce champ ou ajoutez son support au preset."
    })
  );
}
function St(t) {
  const e = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  return e.length > 0 && /^[a-z]/.test(e) ? e : "subject";
}
function _(t, e) {
  return typeof t == "string" && t.trim().length > 0 ? t : e;
}
function T(t) {
  return N(t) ? t : {};
}
function N(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
const vt = /* @__PURE__ */ new Set(["version", "kind", "id", "metadata", "theme", "navigation", "pages"]), yt = /* @__PURE__ */ new Set(["title", "description", "locale"]), _t = /* @__PURE__ */ new Set(["id"]), qt = /* @__PURE__ */ new Set(["mode"]), Et = /* @__PURE__ */ new Set(["id", "title", "description", "elements"]), Lt = /* @__PURE__ */ new Set([
  "id",
  "type",
  "questionType",
  "title",
  "description",
  "required",
  "options",
  "config",
  "validation"
]);
function kt(t, e = V, i = {}) {
  const n = i.mode ?? "authoring", o = { source: t, title: "Formulaire invalide" }, r = [];
  let s;
  try {
    const m = k(t.content, { prettyErrors: !1 });
    if (m.errors.length > 0)
      return {
        status: "invalid",
        fallback: o,
        diagnostics: m.errors.map(
          (E) => c("YAML_SYNTAX_ERROR", E.message, {
            range: M(t.content, E.pos[0], E.pos[1])
          })
        )
      };
    s = m.toJSON();
  } catch (m) {
    const E = m instanceof Error ? m.message : "YAML invalide.";
    return {
      status: "invalid",
      fallback: o,
      diagnostics: [c("YAML_SYNTAX_ERROR", E)]
    };
  }
  if (!S(s))
    return {
      status: "invalid",
      fallback: o,
      diagnostics: [
        c("SCHEMA_INVALID_VALUE", "La source YAML doit definir un objet racine.", {
          path: []
        })
      ]
    };
  const u = ct(s, t.content, r, n);
  if (u.blocking)
    return { status: "invalid", fallback: o, diagnostics: r };
  const a = u.expanded, d = W.safeParse(a);
  if (d.success || r.push(
    ...d.error.issues.map(
      (m) => c("SCHEMA_INVALID_VALUE", Ft(m), {
        path: m.path.map(String),
        range: l(t.content, m.path.map(String)),
        severity: n === "strict" ? "error" : "warning"
      })
    )
  ), r.push(...q(a, vt, [], t.content, n)), At(a, r, t.content, n))
    return { status: "invalid", fallback: o, diagnostics: r };
  const h = S(a.metadata) ? a.metadata : {};
  r.push(...q(h, yt, ["metadata"], t.content, n));
  const f = S(a.theme) ? a.theme : {};
  r.push(...q(f, _t, ["theme"], t.content, n));
  const v = S(a.navigation) ? a.navigation : {};
  r.push(...q(v, qt, ["navigation"], t.content, n));
  const y = {
    id: A(a.id, "form"),
    version: 1,
    kind: "form",
    sourceUri: t.uri,
    sourceHash: K(t.content),
    metadata: {
      title: A(h.title, "Questionnaire"),
      description: b(h.description),
      locale: b(h.locale)
    },
    theme: {
      id: Tt(f.id, e, r, t.content, n)
    },
    navigation: $t(v.mode, r, t.content, n),
    pages: bt(a.pages, e, r, t.content, n)
  }, P = r.filter((m) => m.severity === "error");
  return n === "strict" && P.length > 0 ? { status: "invalid", fallback: o, diagnostics: r } : y.pages.length === 0 && n === "strict" ? {
    status: "invalid",
    fallback: o,
    diagnostics: [
      ...r,
      c("SCHEMA_MISSING_FIELD", "Le formulaire doit contenir au moins une page.", {
        path: ["pages"]
      })
    ]
  } : r.length > 0 ? { status: "degraded", form: y, diagnostics: r } : { status: "valid", form: y, diagnostics: [] };
}
function At(t, e, i, n) {
  let o = !1;
  return t.version !== 1 && (e.push(
    c("FORM_UNSUPPORTED_VERSION", "Seule la version 1 est supportee.", {
      path: ["version"],
      range: l(i, ["version"]),
      hint: "Mettez version: 1 ou migrez la source avant compilation."
    })
  ), o = n === "strict"), t.kind !== "form" && (e.push(
    c("FORM_INVALID_KIND", 'Le champ kind doit valoir "form".', {
      path: ["kind"],
      range: l(i, ["kind"]),
      hint: 'Mettez kind: "form".'
    })
  ), o = n === "strict"), o;
}
function bt(t, e, i, n, o) {
  if (!Array.isArray(t))
    return i.push(
      c("SCHEMA_MISSING_FIELD", "Le formulaire doit definir pages.", {
        path: ["pages"],
        range: l(n, ["pages"]),
        severity: o === "strict" ? "error" : "warning",
        hint: "Ajoutez au moins une page dans pages."
      })
    ), o === "authoring" ? [
      {
        id: "page_1",
        title: "Page 1",
        elements: []
      }
    ] : [];
  const r = /* @__PURE__ */ new Map();
  return t.filter((s) => S(s)).map((s, u) => {
    i.push(...q(s, Et, ["pages", String(u)], n, o));
    const a = typeof s.id == "string" && s.id.length > 0 ? s.id : `page_${u + 1}`;
    (typeof s.id != "string" || s.id.length === 0) && i.push(
      c("PAGE_MISSING_ID", "La page doit definir un id.", {
        severity: o === "strict" ? "error" : "warning",
        path: ["pages", String(u), "id"],
        range: l(n, ["pages", String(u)]),
        hint: "Ajoutez un id stable a la page."
      })
    );
    const d = r.get(a);
    d && i.push(
      c("PAGE_DUPLICATE_ID", `L'id de page "${a}" est duplique.`, {
        path: ["pages", String(u), "id"],
        range: l(n, ["pages", String(u), "id"]),
        pageId: a,
        hint: "Les ids de pages doivent etre uniques dans tout le formulaire.",
        related: [
          {
            message: `Premiere declaration de "${a}" sur la page ${d.index + 1}.`,
            range: d.range
          }
        ]
      })
    ), d || r.set(a, {
      index: u,
      range: l(n, ["pages", String(u), "id"])
    });
    const g = Mt(s.elements, e, i, n, a, u, o);
    return g.length === 0 && i.push(
      c("PAGE_EMPTY", "La page ne contient aucun element.", {
        severity: o === "strict" ? "error" : "info",
        path: ["pages", String(u), "elements"],
        range: l(n, ["pages", String(u), "elements"]),
        pageId: a
      })
    ), {
      id: a,
      title: A(s.title, `Page ${u + 1}`),
      description: b(s.description),
      elements: g
    };
  });
}
function Mt(t, e, i, n, o, r, s) {
  if (!Array.isArray(t))
    return i.push(
      c("SCHEMA_MISSING_FIELD", "La page doit definir elements.", {
        severity: s === "strict" ? "error" : "warning",
        path: ["pages", String(r), "elements"],
        range: l(n, ["pages", String(r), "elements"]),
        pageId: o,
        hint: "Ajoutez elements: [] ou une liste d'elements."
      })
    ), [];
  const u = /* @__PURE__ */ new Map(), a = [];
  return t.forEach((d, g) => {
    if (!S(d)) {
      i.push(
        c("SCHEMA_INVALID_VALUE", "Un element doit etre un objet.", {
          path: ["pages", String(r), "elements", String(g)],
          range: l(n, ["pages", String(r), "elements", String(g)]),
          pageId: o
        })
      );
      return;
    }
    i.push(
      ...q(
        d,
        Lt,
        ["pages", String(r), "elements", String(g)],
        n,
        s
      )
    );
    const h = typeof d.id == "string" && d.id.length > 0 ? d.id : `${o}_element_${g + 1}`;
    (typeof d.id != "string" || d.id.length === 0) && i.push(
      c("ELEMENT_MISSING_ID", "L'element doit definir un id.", {
        severity: s === "strict" ? "error" : "warning",
        path: ["pages", String(r), "elements", String(g), "id"],
        range: l(n, ["pages", String(r), "elements", String(g)]),
        pageId: o,
        elementId: h,
        hint: "Ajoutez un id stable a l'element."
      })
    );
    const f = u.get(h);
    f && i.push(
      c("ELEMENT_DUPLICATE_ID", `L'id d'element "${h}" est duplique dans la page.`, {
        path: ["pages", String(r), "elements", String(g), "id"],
        range: l(n, ["pages", String(r), "elements", String(g), "id"]),
        pageId: o,
        elementId: h,
        hint: "Les ids d'elements doivent etre uniques dans une page.",
        related: [
          {
            message: `Premiere declaration de "${h}" dans l'element ${f.index + 1}.`,
            range: f.range
          }
        ]
      })
    ), f || u.set(h, {
      index: g,
      range: l(n, ["pages", String(r), "elements", String(g), "id"])
    });
    const v = typeof d.type == "string" ? d.type : "question";
    if (v === "statement") {
      a.push({
        id: h,
        type: "statement",
        title: A(d.title, "Information"),
        description: b(d.description)
      });
      return;
    }
    if (v !== "question") {
      i.push(
        c("ELEMENT_UNKNOWN_TYPE", `Le type d'element "${v}" est inconnu.`, {
          path: ["pages", String(r), "elements", String(g), "type"],
          range: l(n, ["pages", String(r), "elements", String(g), "type"]),
          pageId: o,
          elementId: h,
          hint: 'Utilisez type: "question" ou type: "statement".'
        })
      );
      return;
    }
    const y = Nt(d, h, e, i, n, o, r, g);
    y && a.push(y);
  }), a;
}
function Nt(t, e, i, n, o, r, s, u) {
  const a = typeof t.questionType == "string" ? t.questionType : "", d = i.questionTypes.get(a);
  if (!d)
    return n.push(
      c("QUESTION_UNKNOWN_TYPE", `Le type de question "${a || "(vide)"}" est inconnu.`, {
        path: ["pages", String(s), "elements", String(u), "questionType"],
        range: l(o, ["pages", String(s), "elements", String(u), "questionType"]),
        pageId: r,
        elementId: e,
        hint: "Ajoutez le type au runtime ou choisissez un type de question disponible."
      })
    ), null;
  (typeof t.title != "string" || t.title.trim().length === 0) && n.push(
    c("QUESTION_MISSING_TITLE", "La question doit definir un titre.", {
      path: ["pages", String(s), "elements", String(u), "title"],
      range: l(o, ["pages", String(s), "elements", String(u), "title"]),
      pageId: r,
      elementId: e,
      hint: "Ajoutez un titre visible par le participant."
    })
  );
  const g = d.normalizeConfig(S(t.config) ? t.config : d.defaultConfig), h = {
    id: e,
    type: "question",
    questionType: a,
    title: A(t.title, d.defaultTitle),
    description: b(t.description),
    required: t.required === !0,
    options: jt(t.options),
    config: g,
    validation: S(t.validation) ? t.validation : {}
  };
  return n.push(
    ...d.validateConfig(h).map((f) => ({
      ...f,
      path: f.path ?? ["pages", String(s), "elements", String(u), "config"],
      range: f.range ?? l(o, ["pages", String(s), "elements", String(u), "config"]),
      pageId: f.pageId ?? r,
      elementId: f.elementId ?? e
    }))
  ), h;
}
function jt(t) {
  return H(t);
}
function Tt(t, e, i, n, o) {
  const r = typeof t == "string" ? t : "qastia-light";
  return e.themes.has(r) ? r : (i.push(
    c("FORM_UNKNOWN_THEME", `Le theme "${r}" est inconnu.`, {
      severity: o === "strict" ? "error" : "warning",
      path: ["theme", "id"],
      range: l(n, ["theme", "id"]),
      hint: "Ajoutez le theme au runtime ou utilisez un theme disponible."
    })
  ), "qastia-light");
}
function $t(t, e, i, n) {
  return t === void 0 || t === "paged" || t === "single-page" ? t === "single-page" ? "single-page" : "paged" : (e.push(
    c("FORM_INVALID_NAVIGATION_MODE", 'navigation.mode doit valoir "paged" ou "single-page".', {
      severity: n === "strict" ? "error" : "warning",
      path: ["navigation", "mode"],
      range: l(i, ["navigation", "mode"]),
      hint: 'Utilisez navigation.mode: "paged" pour un formulaire pagine.'
    })
  ), "paged");
}
function q(t, e, i, n, o) {
  return Object.keys(t).filter((r) => !e.has(r)).map(
    (r) => c("SCHEMA_UNKNOWN_FIELD", `Champ inconnu "${r}".`, {
      severity: o === "strict" ? "error" : "warning",
      path: [...i, r],
      range: l(n, [...i, r]),
      hint: "Supprimez ce champ ou ajoutez son support au schema public."
    })
  );
}
function Ft(t) {
  const e = t.path.length > 0 ? `Le champ ${t.path.join(".")}` : "La source YAML";
  switch (t.code) {
    case "invalid_type":
      return `${e} a un type invalide : valeur attendue ${t.expected}, valeur recue ${t.received}.`;
    case "invalid_enum_value":
      return `${e} doit utiliser une des valeurs autorisees : ${t.options.join(", ")}.`;
    case "unrecognized_keys":
      return `${e} contient des champs inconnus : ${t.keys.join(", ")}.`;
    default:
      return `${e} est invalide.`;
  }
}
function A(t, e) {
  return typeof t == "string" && t.trim().length > 0 ? t : e;
}
function b(t) {
  return typeof t == "string" && t.length > 0 ? t : void 0;
}
function S(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
export {
  kt as c,
  c as d,
  K as h,
  l as r
};
